import { render, staticRenderFns } from "./OrderDraftProductDialog.vue?vue&type=template&id=f148bf9a&"
import script from "./OrderDraftProductDialog.vue?vue&type=script&lang=js&"
export * from "./OrderDraftProductDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports